import { render, staticRenderFns } from "./DeleteCommentModal.vue?vue&type=template&id=02b9cfcb&scoped=true"
import script from "./DeleteCommentModal.vue?vue&type=script&lang=js"
export * from "./DeleteCommentModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteCommentModal.vue?vue&type=style&index=0&id=02b9cfcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b9cfcb",
  null
  
)

export default component.exports